import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useCallback, useEffect } from 'react';

/**
 * @author pjh
 * @date 2025.08.04
 * @description 회원가입 실패 시 보여주는 에러 모달 컴포넌트
 */
const RegistrationErrorModal = ({
  isOpen,
  setIsOpen,
  errorMessage,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  errorMessage: string;
}) => {
  const onClickClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  // ESC key event handler
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClickClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClickClose]);

  if (!isOpen) return null;

  return (
    <div className="!fixed !inset-0 !z-60 !flex !items-center !justify-center !p-4 !bg-black !bg-opacity-50">
      <div className="!bg-white !rounded-2xl !shadow-2xl !w-full !max-w-sm !relative !animate-fadeIn">
        {/* 닫기 버튼 */}
        <button
          onClick={onClickClose}
          className="!absolute !top-4 !right-4 !w-10 !h-10 !rounded-full !bg-gray-100 hover:!bg-gray-200 !flex !items-center !justify-center !transition-colors"
        >
          <FontAwesomeIcon icon={faTimes} className="!text-gray-600" />
        </button>
        
        {/* 내용 */}
        <div className="!px-8 !py-8 !text-center">
          {/* 에러 아이콘 */}
          <div className="!inline-flex !items-center !justify-center !w-16 !h-16 !bg-red-100 !rounded-full !mb-4">
            <FontAwesomeIcon icon={faExclamationCircle} className="!text-red-500 !text-3xl" />
          </div>
          
          {/* 제목 */}
          <h3 className="!text-xl !font-bold !text-gray-800 !mb-2">회원가입 실패</h3>
          
          {/* 에러 메시지 */}
          <p className="!text-gray-600 !mb-6 !whitespace-pre-line">{errorMessage}</p>
          
          {/* 확인 버튼 */}
          <button
            onClick={onClickClose}
            className="!w-full !py-3 !px-4 !bg-gradient-to-r !from-indigo-500 !to-purple-600 !text-white !font-medium !rounded-lg !shadow-lg hover:!shadow-xl !transform hover:!-translate-y-0.5 !transition-all !duration-200"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationErrorModal;